<template>
    <div class="details">
        <header class="title">
            <span class="pole"></span>
            <span class="str">基本信息</span>
            <van-icon :name="show ? 'arrow-down' : 'arrow'" class="show" @click="showSurplusEvent"></van-icon>
        </header>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">监审部门</van-col>
            <van-col span="16" class="lr">{{ info.auditOrgName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">项目经理</van-col>
            <van-col span="16" class="lr">{{ info.projectChiefJudgeName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">被审单位</van-col>
            <van-col span="16" class="lr">{{ info.auditeeOrgName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">计划年度</van-col>
            <van-col span="16" class="lr">{{ info.annual }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">项目来源</van-col>
            <van-col span="16" class="lr">{{ info.projectSourceName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">项目类型</van-col>
            <van-col span="16" class="lr">{{ info.projectTypeName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">项目等级</van-col>
            <van-col span="16" class="lr">{{ info.projectDegreeName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">业务领域</van-col>
            <van-col span="16" class="lr">{{ info.businessFiledName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">二级流程</van-col>
            <van-col span="16" class="lr">{{ info.twoLevelProcessName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">三级流程</van-col>
            <van-col span="16" class="lr">{{ info.threeLevelProcessName }}</van-col>
        </van-row>
        <!-- 折叠的数据 -->
        <div v-show="show">
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">管理者</van-col>
                <van-col span="16" class="lr">{{ info.projectPmName }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">执行日期</van-col>
                <van-col span="16" class="lr">{{ info.executeDateStr }}</van-col>
            </van-row>
            <ul class="content">
                <li class="caption" style="margin-bottom: 7px;">项目背景</li>
                <li>
                    {{ getAuditBackground }}
                    <span style="color: #999;" v-if="info.auditBackground.length > 60" @click="expandHideEvent('auditBackground')">{{ visible.auditBackground ? " 收起" : "...展开" }}</span>
                </li>
            </ul>
            <ul class="content">
                <li class="caption" style="margin-bottom: 7px;">项目目标</li>
                <li>
                    {{ getAuditObjective }}
                    <span style="color: #999;" v-if="info.auditObjective.length > 60" @click="expandHideEvent('auditObjective')">{{ visible.auditObjective ? " 收起" : "...展开" }}</span>
                </li>
            </ul>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">业务时间范围</van-col>
                <van-col span="16" class="lr">{{ info.businessTimeRange }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">项目成员</van-col>
                <van-col span="16" class="lr">
                    <span v-for="(item,index) in info.projectMembers" :key="index">
                        <span v-if="index != 0">、</span>{{ item }}
                    </span>
                </van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        info: {
            type: Object,
            require: true
        }
    },
    data(){
        return {
            show: false,
            visible: {
                auditBackground: false,
                auditObjective: false
            }
        }
    },
    methods: {
        showSurplusEvent(){
            this.show = !this.show;
        },
        expandHideEvent(name){
            this.visible[name] = !this.visible[name];
        },
    },
    computed: {
        getAuditBackground(){
            return this.visible.auditBackground ? this.info.auditBackground : this.info.auditBackground.slice(0,60);
        },
        getAuditObjective(){
            return this.visible.auditObjective ? this.info.auditObjective : this.info.auditObjective.slice(0,60);
        }
    },
}
</script>
<style lang="less" scoped>
    //主标题字号
    @titleSize: 16px;
    //主标题颜色
    @titleColor: #0ea6e0;
    //中等字号
    @middleSize: 14px;
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;

    //板块radius
    @borderRadius: 4px;

    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);

    //预览标题颜色
    @previewColor: #000;
    .details{
        background-color: #fff;
        border-radius: @borderRadius;
        box-shadow: @boxShadow;
        overflow: hidden;
        margin-top: 15px;
        padding-bottom: 10px;
        text-align: left;
        font-size: @contentSize;
        .title{
            margin: 20px 15px 0 15px;
            text-align: left;
            overflow: hidden;
            position: relative;
            .pole{
                color: @titleColor;
                font-size: @titleSize;
                border-left: 3px solid #0ea6e0;
            }
            .str{
                width: 100%;
                font-size: @middleSize;
                display: inline-block;
                margin-left: 5px;
                font-weight: bold;
                padding-bottom: 5px;
                border-bottom: 1px solid #d7d7d7;
            }
            
            .show{
                position: absolute;
                right: 0;
                top: 4px;
            }
        }
        .content{
            margin: 10px 15px 5px 23px;
            padding-bottom: 3px;
            border-bottom: 1px solid #f3f3f3;
            .caption{
                color: @contentColor;
                img{
                    border: 1px solid #000 !important;
                    border-radius: @borderRadius !important;
                }
            }
            .lr{
                text-align: right;
            }
        }
        .content:last-child{
            border: unset;
        }
    }
</style>